export enum TokenTypes {
  id = 'id',
  refresh = 'refresh',
  access = 'access',
}
